class RelayError extends Error {
    constructor(errorMessage: string) {
        super(errorMessage)

        this.name = 'Relay Error'
    }
}

export default RelayError
